import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { PanelService } from 'src/app/modules/shared/services/api/panel.service';
import { StoreDetailService } from 'src/app/modules/shared/services/resolver/store-detail.service';
import { WalletBalanceService } from 'src/app/modules/shared/services/resolver/wallet-balance.service';
import { StateService } from 'src/app/modules/shared/services/storage/state.service';
import { ChargeWalletSheetComponent } from '../charge-wallet-sheet/charge-wallet-sheet.component';
import { Location } from '@angular/common';
import { DeviceDetectorService } from 'src/app/modules/shared/services/device-detector/device-detector.service';

@Component({
  selector: 'app-wallet',
  templateUrl: './wallet.component.html',
  styleUrls: ['./wallet.component.scss'],
})
export class WalletComponent implements OnInit {
  transactions: any;
  gatewayList: any;
  isTransaction: any;
  walletCheckdetail: any;
  notFound: boolean = false;
  orderDetail: any;
  paymentDetail: any;
  remaining: any;
  storeDetail: any;
  isCashback: boolean = false;
  isCharge: boolean = false;
  tranaction: any;
  orderId: any;
  statusCode: any;
  isPurchase: boolean = false;
  isRefund: boolean = false;
  isListEmpty: boolean = false;
  isDesktop: boolean = false;
  result: any;
  displayedColumns: string[] = ['title', 'amount', 'transaction_id', 'type', 'date'];

  @ViewChild('transactionDetail') transactionDetail: any;
  @Output() isChargeWallet = new EventEmitter<any>();

  constructor(
    private panelService: PanelService,
    private bottomSheet: MatBottomSheet,
    private dialog: MatDialog,
    private router: Router,
    private walletBalance: WalletBalanceService,
    private stateService: StateService,
    private storeDetailResolver: StoreDetailService,
    private location: Location,
    private deviceDetectorService: DeviceDetectorService,
  ) {
    this.isDesktop = this.deviceDetectorService.isDesktop;
  }

  ngOnInit(): void {
    this.getWalletBalance();
    this.getStoreDetail();
    this.getWalletTransactions();
    this.getGatewayList();
    this.checkWalletReload();
  }

  getWalletBalance() {
    this.walletBalance.permissionInitInfo.subscribe((remaining) => {
      this.remaining = remaining;
    });
  }

  getStoreDetail() {
    this.storeDetail = this.storeDetailResolver.permissionInit;
  }

  checkWalletReload() {
    this.stateService.getIsWalletReloaded().subscribe((iswalletReload) => {
      if (iswalletReload) {
        this.getWalletTransactions();
        this.getGatewayList();
        this.stateService.setIsWalletReloaded(false);
      }
    });
  }

  getWalletTransactions() {
    this.panelService.getWalletTransactions().subscribe((data) => {
      this.transactions = data;
      this.isTransaction = data.length;
      if (data?.length == 0 || (data.length == 1 && data[0].status_code == 50)) {
        this.isListEmpty = true;
      }
    });
  }
  openBottomSheet() {
    let bottomSheetRef = this.bottomSheet.open(ChargeWalletSheetComponent, {
      data: this.gatewayList,
    });

    bottomSheetRef.afterDismissed().subscribe(res => {
      this.getWalletTransactions();
    });
  }

  getGatewayList() {
    this.panelService.getGatewayList().subscribe((gateways) => {
      this.gatewayList = gateways;
    });
  }

  openTransactionDetail() {
    if (this.orderDetail === null && this.paymentDetail === null) {
      this.notFound = true;
    }

    if (this.orderId && this.statusCode == 51) {
      this.isCashback = true;
      this.isCharge = false;
      this.isPurchase = false;
      this.isRefund = false;
    } else if (!this.orderId && this.statusCode == 51) {
      this.isCharge = true;
      this.isCashback = false;
      this.isPurchase = false;
      this.isRefund = false;
    } else if (this.statusCode == 52) {
      this.isPurchase = true;
      this.isRefund = false;
      this.isCashback = false;
      this.isCharge = false;
    } else if (this.statusCode == 53) {
      this.isRefund = true;
      this.isCashback = false;
      this.isCharge = false;
      this.isPurchase = false;
    }

    if (this.orderDetail === null) {
      if (this.orderId) {
        this.panelService.getOrderDetail(this.orderId).subscribe((res) => {
          this.result = res;
          this.showDialog();
        });
      } else {
        this.result = this.walletCheckdetail;
        this.showDialog();
      }
    } else {
      this.result = this.orderDetail;
      this.showDialog();
    }
  }

  showDialog() {
    this.dialog.open(this.transactionDetail, {
      width: '500px',
    });
  }

  getDetail(transaction: any) {
    this.isCashback = false;
    this.isCharge = false;
    this.walletCheckdetail = '';
    this.notFound = false;
    this.tranaction = transaction;
    let statusCode;
    if (transaction?.status_code == 52 || transaction?.status_code == 53) {
      statusCode = 1;
    } else if (transaction?.status_code == 51) {
      statusCode = 2;
    }
    let filter = {
      transaction_id: transaction?.transaction_id,
      check_type: statusCode,
    };

    this.panelService.walletTransactionCheck(filter).subscribe((res) => {
      this.walletCheckdetail = res;
      this.orderDetail = res?.order_detail;
      this.paymentDetail = res?.payment_detail;
      this.orderId = res?.payment_detail?.order;
      this.statusCode = res?.status_code;
      this.openTransactionDetail();
    });
  }

  onBack() {
    this.location.back();
  }

  onChargeWallet() {
    if(this.isDesktop) {
      this.isChargeWallet.emit(true)
    } else {
      this.router.navigate(['/wallet', 'charge'])
    }
  }
}
